import { render, staticRenderFns } from "./StatBox.vue?vue&type=template&id=c81c97ce&scoped=true&"
import script from "./StatBox.vue?vue&type=script&lang=js&"
export * from "./StatBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81c97ce",
  null
  
)

export default component.exports